module.exports = __webpack_public_path__ + "static/media/gift-dynamic-clay.fecafd37.png";